/**
 * Shared CLI logging: timestamped lines to stdout.
 */

import { getCliLogVerbosity } from './cli-log-level.js';

export type LogFn = (line: string) => void;

function timestampPrefix(): string {
  const time = new Date().toISOString().slice(11, 19);
  return `[${time}]`;
}

/**
 * Log a line with a [HH:mm:ss] prefix to stdout.
 */
export function log(line: string): void {
  console.log(`${timestampPrefix()} ${line}`);
}

/** Same timestamp format as `log`, written synchronously to stdout (avoids delay before TTY flush). */
export function logImmediate(line: string): void {
  process.stdout.write(`${timestampPrefix()} ${line}\n`);
}

/** Debug-level line (shown with `--debug` or `--trace`). */
export function logDebug(line: string): void {
  const v = getCliLogVerbosity();
  if (v !== 'debug' && v !== 'trace') return;
  console.log(`${timestampPrefix()} [debug] ${line}`);
}

/** Trace-level line (shown only with `--trace`), e.g. git subprocess output. */
export function logTrace(line: string): void {
  if (getCliLogVerbosity() !== 'trace') return;
  console.log(`${timestampPrefix()} [trace] ${line}`);
}
